import { FaChartLine, FaCog } from "react-icons/fa";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import aboutImage1 from "../assets/aboutSection_1.jpg"; // Replace with your about image path
import bgImage from "../assets/about-bg.jpg"; // Replace with your background image path

import circleImage from "../assets/circle.png"; // Replace with your circle image path

export default function AboutSection() {
  return (
    <div
      className=" px-4 py-16 bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >

      <div className="grid lg:grid-cols-2 items-center gap-12">
        {/* Left Section */}
        <div className="relative flex justify-center">
  {/* Rotating Circle (Behind the Image) */}
  <motion.img
    src={circleImage}
    alt="Decorative Circle"
    className="absolute -top-12 right-5 w-40 h-40 sm:w-48 sm:h-48 opacity-100 z-0"
    animate={{ rotate: 360 }}
    transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
  />

  {/* About Image */}
  <motion.img
    src={aboutImage1}
    alt="About Us"
    className="relative rounded-lg shadow-lg max-w-full h-auto object-cover w-[300px] sm:w-[350px] md:w-[400px] lg:w-[500px] lg:h-[500px] border-4 border-[#4898a5] z-10"
    initial={{ opacity: 0, x: -50 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5 }}
  />

  {/* Overlay box */}
  <motion.div
    className="absolute bg-white rounded-lg shadow-md p-4 flex items-center gap-4 -bottom-8 left-8 z-20"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.5, duration: 0.5 }}
  >
    <div className="bg-blue-100 p-3 rounded-full">
      <FaChartLine className="text-[#4898a5] w-6 h-6" />
    </div>
    <div>
      <h4 className="text-2xl font-bold text-gray-800">
        <CountUp end={6561} duration={2.5} separator="," />+
      </h4>
      <p className="text-gray-500 text-sm">Happy Clients</p>
    </div>
  </motion.div>
</div>


        {/* Right Section */}
        <div className="space-y-10">
          <div>
            <h2 className="text-[#504e9a] font-medium">ABOUT APPNEXTS</h2>
            <h1 className="text-4xl lg:text-5xl font-bold">
              We Are Increasing Business Success With{" "}
              <span className="text-[#4898a5]">Technology</span>
            </h1>
            <p className="text-gray-800 mt-4">
            At <span className="font-semibold">AppNexts</span>, we specialize in providing innovative IT services and developing cutting-edge projects that help businesses thrive in the digital age.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { icon: FaCog, title: "Problem Solving" , description:"Solving complex challenges with innovative and efficient solutions" },
              { icon: FaChartLine, title: "Mission & Vision", description:"Empowering innovation, transforming ideas into impact." },
            ].map((feature, index) => (
              <motion.div
  key={feature.title}
  className="flex items-start gap-4"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.5 + index * 0.2, duration: 0.5 }}
>
  <div className="bg-[#4898a5] p-3 rounded-full">
    <feature.icon className="text-white w-6 h-6" />
  </div>
  <div>
    <h3 className="font-bold text-xl text-gray-800">{feature.title}</h3>
    <p className="text-gray-600 text-sm ">{feature.description}</p>
  </div>
</motion.div>

            ))}
          </div>

          {/* CTA */}
          <div className="flex items-center gap-6">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 bg-[#504e9a] text-white rounded-lg font-bold transition"
            >
              Explore More
            </motion.button>

          </div>
        </div>
      </div>
    </div>
  );
}


